//import liraries
import React, {  useEffect, useState, useRef } from "react";
import { View, Text, Image, TouchableOpacity, TextInput, Linking,} from "react-native";
import CustomButton from "../../common/CustomButton";
import {getCreditCardDetails,getAutoRechargeDtls,sendOtp,validateOtpWithToken,getPoolAccountdetail } from "../../api/apiManager";
import { get } from "lodash";
import QuickLinks from "../Profile/QuickLinks";
import CustomInput from "../../common/CustomInput";
import ModalAlert from "../../common/ModalAlert";
import ModalAlertForTwoButtons from "../../common/ModalAlertForTwoButtons";
import Loader from "../../common/Loader";
import RootNavigation from "../../utilities/RootNavigation";
import CountdownTimer from "../../common/CTimer.web";
import useStyles from "./Pool_AutoRecharge_Styles";
import CText from "../../common/CText";
// create a component
const Pool_AutoRecharge = (props) => {
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("500");
  const [creditCardModal, setCreditCardModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [maskedAccNum, setMaskedAccNum] = useState("");
  const [errMessage, setErrMessage] = useState( "IDFC FIRST Bank Credit Card is not linked with your mobile number. Would you like to apply?");
  const [data, setData] = useState([]);
  const [ccdata, setccData] = useState([]);
 const [otpNbr, setOtpNbr] = useState("");
  const [otpMsg, setOtpMsg] = useState("");
  const [errModalVisible, setErrModalVisible] = useState(false);
  const [otpData, setOtpData] = useState("");
 const [requestId, setRequestId] = useState("");
  const [showUpdate, setShowUpdate] = useState(false)
  const otpPattern = /^\d{6}$/;
  const [selectedCard, setSelectedCard] = useState({});
  const parsed = parseFloat(amount).toFixed(2);
  const [thresholdAmt, setThresholdAmt] = useState(0);
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [otp, setOtp] = useState();
  const styles = useStyles();
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [poolData, setPoolData] = useState({})
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });
  const counterRef = useRef(null);
useEffect(() => {
    if (ccdata?.isAutoRechEnabled == "Y" && thresholdAmt != ccdata?.thresholdAmt) {
      setShowUpdate(true)
    }
  }, [thresholdAmt])
 useEffect(() => {
    getPoolAccountDtls();
  }, []);
 useEffect(() => {
  }, [props?.params])
 const getMaskedNum = (string) => {
    let new_string = string.replace(/\b[\dX][-. \dX]+(\d{4})\b/g, function (match, capture) {
      return Array(match.length - 4).join("X") + capture;
    });
    return new_string
   }
const getPoolAccountDtls = () => {
    setLoading(true);
    getPoolAccountdetail()
      .then((res) => {
        console.log("enableAutopay res1", res);
        setPoolData(res);
        setMaskedAccNum(getMaskedNum(res?.accountNo || ""))
        getAutoRechargeDetails(res?.accountNo);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
const getCreditCardDtls = () => {
    setLoading(true);
    getCreditCardDetails()
      .then((res) => {
        console.log("getCreditCardDtls", res);
        if (res.statusCode == 200) {
          setData(res?.data || []);
          setCreditCardModal(true);
          }
        if (res.statusCode == -1057) {
          setErrMessage(res.message || "");
          setErrModalVisible(true);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
          });
        }
      })
      .catch((err) => {
        console.log("getCreditCardDtls", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
 const getAutoRechargeDetails = (accountNo) => {
    setLoading(true);
    let params = { vrn: "", poolAccountNumber: accountNo };
    console.log(params)
    getAutoRechargeDtls(params)
      .then((res) => {
        setccData(res.data);
        setThresholdAmt(res?.data?.thresholdAmt);
        setAmount(res?.data?.rechargeAmt || "500");
        setIsEdit(res?.data?.isAutoRechEnabled == "N" ? true : false);
      })
      .catch(() => { })
      .finally(() => {
        setLoading(false);
      });
  };
 const getOtp = (item) => {
    console.log(props.selectedVrnData);
  var params = {
      id: global.userCd,
      type: "autoRecharge",
      poolAccountNumber: poolData?.accountNo
    };
    setLoading(true);
    setCreditCardModal(false);
    sendOtp(params)
      .then((response) => {
        let res = response?.data;
        if (res.statusCode == 1003 || res.statusCode == 200) {
          setLoading(false);
          setRequestId(res?.response);
          setOtpMsg(res.message);
          setOtpData(res);
          setOtpModalVisible(true);
        } else if (
          res.statusCode == -1052 ||
          res.statusCode == 500 ||
          res.statusCode == -1017 ||
          res.statusCode == -1003 ||
          res.statusCode == -1004
        ) {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        setLoading(false);
      });
  };
  const onClickValidateOtp = () => {
    let fastagId = 0;
    let reqObj = {
      requestId: requestId?.otp,
      otp: otp,
      type: "autoRecharge",
      vrn: "",
      cardSerno: selectedCard.cardSerNo || ccdata?.cardSerNo,
      maskedCard: selectedCard.maskedCardNumber || ccdata?.maskedCardNo,
      maskedCardNumber: selectedCard.maskedCardNumber || ccdata?.maskedCardNo,
      thresholdAmt: thresholdAmt,
      rechargeAmt: amount,
      tagId: "",
      poolAccountNumber: poolData?.accountNo
    };
    setLoading(true);
    validateOtpWithToken(reqObj)
      .then((res) => {
        setOtp("");
     if (
          res.statusCode == 200 ||
          res.statusCode == 1020 ||
          res.statusCode == 1034 ||
          res.statusCode == 1053
        ) {
          setLoading(false);
          setOtpModalVisible(false);
          setOtpNbr("");
          setAlertModal({
            title: "Successful",
            status: "success",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
            isSuccess:true
          });
          setAlertModalVisible(true);
        } else if (
          res.statusCode == -1020 ||
          res.statusCode == 500 ||
          res.statusCode == -1008 ||
          res.statusCode == -1053 ||
          res.statusCode == -1017 ||
          res.statusCode < 0
        ) {
          setOtpModalVisible(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false);
          setOtpNbr("");
        } else {
          setOtpModalVisible(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false);
          setOtpNbr("");
        }
      })
      .catch((err) => {
        console.log("ERROR ", err);
         setOtpModalVisible(false);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        setLoading(false);
        setOtpNbr("");
      });
  };
const renderCard = () => {
    return data.map((item, index) => {
      return (
        <View
          key={index}
          style={styles.cardCreditStyle} >
          <View style={styles.viewStyle}>
           <CText.CCardStyle> {"IDFC FIRST Bank Credit Card"}</CText.CCardStyle>
             <Image
              source={
                item.prdctShortCode == "VISA"
                  ? require("../../assets/images/visa.png"):
                  item?.prdctShortCode == "RUPAY" ? require("../../assets/images/rupay.png")
                  : require("../../assets/images/master.png")
              }
              style={{width: 41.2,height: item?.prdctShortCode == "MASTER" ? 23.7 : 11.7, }}
            />
          </View>
          <CText.MaskCard style={{paddingTop: 10,opacity: 0.6,}}> {item.maskedCardNumber} </CText.MaskCard>
          <View style={{ width: 107,height: 26.3,alignSelf: "flex-end"}}>
            <CustomButton
              text={"Link and Setup"}
              textStyle={{fontFamily: "Inter",fontSize:10,fontWeight: "bold",fontStyle: "normal",lineHeight: 14,letterSpacing: -0.24,textAlign: "left",color: "#ffffff",}}
              onPress={() => {
                getOtp();
                setSelectedCard(item);
              }}
            />
          </View>
        </View>
      );
    });
  };
  const onCloseModal = () => {
    setAlertModalVisible(false);
    RootNavigation.navigate("Profile/PoolAccount",{isAutoRechEnabled : alertModal?.isSuccess})
  };
  return (
    <View style={styles.container}>
      <View style={styles.backIconViewStyle}>
        <TouchableOpacity
          onPress={() => {RootNavigation.navigate("Profile/PoolAccount")}}> 
          <Image source={require("../../assets/images/back_icon.png")} style={styles.backIconStyle} />
        </TouchableOpacity>
     <CText.viewVehicleTextStyle style={{paddingLeft: 15}}>{"Auto Recharge"}</CText.viewVehicleTextStyle>
      </View>
      <View style={styles.contentViewStyle}>
        <View>
          <CText.headingTextStyle style={{paddingBottom: 5}}>{"Recharge when my balance goes below"}</CText.headingTextStyle>
          <View style={styles.containerBorder}>
            <View style={styles.cardContainer}>
              <Image source={require("../../assets/images/Card_Image_Pool.png")} style={{ width: 82, height: 84, resizeMode: "contain" }} />
              <View style={styles.innerContainer}>
               <CText.cardNUmberTextStyle onPress={() => {
                  setMaskedAccNum(poolData?.accountNo)
                  setTimeout(() => {
                    setMaskedAccNum(getMaskedNum(poolData?.accountNo))
                  }, 30000)  }}> {maskedAccNum}</CText.cardNUmberTextStyle>
             <CText.poolAcTextStyle>Pool Account No.</CText.poolAcTextStyle>
            <View style={{flexDirection: "row",justifyContent: "space-between",marginVertical: 15,}} >
                  <Image source={require("../../assets/images/ic_toll.png")} style={{ width: 33, height: 26, color: "#601828" }} />
                  <View style={{ marginLeft: 10 }} >
                   <CText.amountTextStyle>{get(poolData, "accountBal", 0).toFixed(2)}</CText.amountTextStyle>
                   <CText.poolAcTextStyle style={{paddingTop: 3}}>Pool Account Bal.</CText.poolAcTextStyle>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={{ marginTop: 20 }}>
             <CText.headingTextStyle>{"Recharge when my balance goes below"}</CText.headingTextStyle>
            <View>
              <TextInput  style={[styles.textInputStyle,  { backgroundColor: isEdit ? "#fff" : "#f8f8f8" },  ]}  maxLength={6}  value={thresholdAmt}  onChangeText={(t) => (isNaN(t) ? "" : t.includes(".") ? "" : setThresholdAmt(t))}  editable={isEdit}  />
              {isEdit ? (null) : (
               <TouchableOpacity style={{ position: "absolute", zIndex: 999, right: 10, top: 8,  }} onPress={() => setIsEdit(true)} >
                <CText.PoolEditBtn> {"Edit"} </CText.PoolEditBtn>
               </TouchableOpacity>
              )}
            </View>
          </View>
        </View>
        <View style={styles.secondViewStyle}>
           <CText.headingTextStyle>{"Recharge with"}</CText.headingTextStyle>
          <View style={styles.quickAddButtons}>
            <TouchableOpacity style={[styles.quickAddButton,{  backgroundColor: amount == 500 ? "#ffffff" : "#ffdfe2",  borderWidth: amount == 500 ? 1 : 0,  borderColor: amount == 500 ? "#bd2d37" : null,}, ]}
              onPress={() => {
                setAmount(500)
                ccdata?.isAutoRechEnabled == "Y" ? setShowUpdate(true) : ""  }}>
                    <CText.qabInnerText>500</CText.qabInnerText>
            </TouchableOpacity>
             <TouchableOpacity  style={[ styles.quickAddButton, { backgroundColor: amount == 1000 ? "#ffffff" : "#ffdfe2", borderWidth: amount == 1000 ? 1 : 0, borderColor: amount == 1000 ? "#bd2d37" : null,  }, ]}
              onPress={() => {
                setAmount(1000)
                ccdata?.isAutoRechEnabled == "Y" ? setShowUpdate(true) : ""
              }}>
               <CText.qabInnerText>1000</CText.qabInnerText>
            </TouchableOpacity>
           <TouchableOpacity  style={[ styles.quickAddButton,  { backgroundColor: amount == 1500 ? "#ffffff" : "#ffdfe2", borderWidth: amount == 1500 ? 1 : 0, borderColor: amount == 1500 ? "#bd2d37" : null, },  ]}
              onPress={() => {
                setAmount(1500)
                ccdata?.isAutoRechEnabled == "Y" ? setShowUpdate(true) : ""
              }}  >
             <CText.qabInnerText>1500</CText.qabInnerText>
            </TouchableOpacity>
          </View>
         <CText.PoolText style={{paddingTop: 10,}}>{"Select different number if you wish change the recharge amount"}</CText.PoolText>
          {ccdata?.isAutoRechEnabled !== "N" ? (
            <View>
              <View style={{ flexDirection: "row", justifyContent: "space-between",  }} >
                 <CText.headingTextStyle style={{ marginTop: 15}}>{"Selected Payment Method"}</CText.headingTextStyle>
                <TouchableOpacity onPress={() => getCreditCardDtls()}>
                  <CText.headingTextStyle style={{marginTop: 15,color: "#cb0303",marginLeft: 20,}}>{"Change"}</CText.headingTextStyle>
                </TouchableOpacity>
              </View>
              <View style={{ width: 280, height: 81.8, backgroundColor: "#ffffff", borderStyle: "solid", borderWidth: 1, borderColor: "#ccd0d5", borderRadius: 10, padding: 10, marginTop: 10, }} >
                <View style={styles.viewStyle}>
                  <CText.CCardStyle>{"IDFC FIRST Bank Credit Card"}</CText.CCardStyle>
                  <Image  source={
                      ccdata?.prdctShortCode == "VISA"
                        ? require("../../assets/images/visa.png"):
                        ccdata?.prdctShortCode == "RUPAY" ? require("../../assets/images/rupay.png")
                        : require("../../assets/images/master.png") }
                    style={{ width: 41.2, height: ccdata?.prdctShortCode == "MASTER" ? 23.7 : 11.7,  }}/>
                </View>
                 <CText.MaskCard style={{ paddingTop: 10, opacity: 0.6,}}>{ccdata?.maskedCardNo}</CText.MaskCard>
              </View>
            </View>
          ) : (
            <View>
            <CText.headingTextStyle style={{ marginTop: 15,}}>{"Choose from Available Payment Methods"}</CText.headingTextStyle>
              <TouchableOpacity style={styles.paymentMethodViewStyle}  onPress={() => getCreditCardDtls()}  >
                 <CText.paymentMethodTextStyle>{"IDFC FIRST Bank Credit Card"}</CText.paymentMethodTextStyle>
                <Image source={require("../../assets/images/icon_arrow_right.png")} style={{width: 8.4,height: 12.9,resizeMode: "contain", }} />
              </TouchableOpacity>
             </View>
          )}
        </View>
        {!showUpdate ? (null) : (
           <View style={styles.updateButtonStyle}>
            <CustomButton text={"Update"} onPress={() => getOtp()} />
          </View>
        )}
      </View>
      <View>
        <QuickLinks
          navigation={props.navigation}
          activeScreen={"Pool Account Details"}
          setScreen={(layout) => props?.setScreen(layout)}
          setIsManual={(layout) => props?.setSelectedLayout(layout)}
          setSelectedLayout={props?.setSelectedLayout}
        />
      </View>
      {creditCardModal ? (
        <View style={styles.overlayViewStyle}>
          <View style={styles.overlayContainer}>
            <View style={styles.creditOverlay}>
              <TouchableOpacity style={{ alignSelf: "flex-end", }} onPress={() => setCreditCardModal(false)} >
                <Text style={{ margin: 15, marginBottom:0,color: "#bd2d37", fontFamily: "Inter" }}> {"X"}  </Text>
              </TouchableOpacity>
              <CText.selectCCstyle>{"Please select a card for setting up Auto Recharge"}</CText.selectCCstyle>
              <View>
                <View style={styles.viewStyle1}  > {renderCard()} </View>
              </View>
            </View>
          </View>
        </View>
      ) : null}
      {otpModalVisible ? (<View style={styles.overlayViewStyle}>
          <View style={styles.overlayContainer}>
            <View style={styles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <Text style={styles.enterOtpTextStyle}>{"Enter OTP"}</Text>
                <Text style={styles.otpDescTextStyle}> {get(otpData, "message", "")} </Text>
                <View style={{ alignSelf: "center" }}>
                  <CustomInput
                    onValueChanged={(e) => setOtp(e)}
                    value={otp}
                    keyboardType="numeric"
                    pattern={/^\d{6}$/}
                    errorMessage={"Enter Valid OTP"}
                    maxLength={6}
                    style={[styles.otpInputViewStyle, { alignSelf: "center" }]}
                  />
                </View>
                <View style={styles.resendViewStyle}>
                  <CountdownTimer
                  requestOtp={otpModalVisible}
                    onClickGetOtp={getOtp}
                    counterRef={counterRef} />
               </View>
                <View  style={{width: 123.5,height: 36,alignSelf: "center",marginTop: 20, }}  >
                  <CustomButton
                    text={"Submit"}
                    onPress={() => { !otpPattern.test(otp) ? null : onClickValidateOtp(); }}
                    disable={!otpPattern.test(otp) ? true : false}  />
                </View>
              </View>
            </View>
          </View>
        </View> ) : null}
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
      {errModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlertForTwoButtons title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen} actionButton1={"Later"} actionButton2={"Apply Now"} onPressActionButton1={() => { setErrModalVisible(false);  }}
            onPressActionButton2={() => {
              setErrModalVisible(false)
              Linking.openURL(global?.AUTO_RECHARGE_APPLY_LINK)
            }}
            backgroundColor={"#bd2d37"}
            color={"#ffffff"}
          />
        </View> ) : null}
      {loading && <Loader />}
    </View>
  );
};
//make this component available to the app
export default Pool_AutoRecharge;
